<lib-dlg titulo="Cadastro de Localização" nome="dlgProdutoLocalizacao" styleClassHeader="text-white bg-primary"
  (onHide)="sair()" [visualizar]="visualizar">
  <form [formGroup]="entidadeForm" autocomplete="off">
    <div class="row">
      <div class="col-12">
        <div class="tab-pane fade show active" id="principal" role="tabpanel" aria-labelledby="principal-tab">
          <div class="form-row">
            <div class="form-group col-md-3">
              <label for="sala">Sala<span class="text-danger">*</span></label>
              <input #sala_ id="sala" formControlName="sala" type="text" class="form-control">
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-12">
              <label for="armario">Armário<span class="text-danger">*</span></label>
              <input id="armario" formControlName="armario" type="text" class="form-control font-weight-bold">
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-12">
              <label for="prateleira">Prateleira<span class="text-danger">*</span></label>
              <input id="prateleira" formControlName="prateleira" type="text" class="form-control">
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
  <ng-container opcoes>
    <button (click)="submitForm()" type="submit" class="btn btn-primary btn-sm float-right ml-2">Salvar</button>
  </ng-container>
</lib-dlg>